import { useMessageBusDispatch, messageBusUtil } from '../../context/messagebus';
import { useLog } from '../hooks/useLog';
const useMessageBusCallbacks = () => {
  const messageBusDispatch = useMessageBusDispatch();
  const {
    log
  } = useLog();
  const latestHandler = data => {
    log('MessageBus', 'latestHandler', data);
    if ((data === null || data === void 0 ? void 0 : data.message_type) === 'latest') {
      messageBusDispatch({
        type: 'ADD_ITEM_TO_REPLIES',
        payload: messageBusUtil.createPayload(data)
      });
    }
  };
  const newHandler = data => {
    // new topic
    log('MessageBus', 'newHandler', data);
    if ((data === null || data === void 0 ? void 0 : data.message_type) === 'new_topic') {
      // set active to false when update_in_progress
      // const active = messageBusState.update_in_progress === true ? false : true;
      messageBusDispatch({
        type: 'ADD_ITEM_TO_TOPICS',
        payload: messageBusUtil.createPayload(data)
      });
    }
  };
  const notificationAlertHandler = data => {
    log('MessageBus', 'notificationAlertHandler', data);
    // ## mention
    if ((data === null || data === void 0 ? void 0 : data.notification_type) === 1) {
      messageBusDispatch({
        type: 'SET_ACTIVITY_TIMESTAMP',
        payload: Date.now()
      });
    }

    // ## new reply
    else if ((data === null || data === void 0 ? void 0 : data.notification_type) === 2) {
      messageBusDispatch({
        type: 'ADD_ITEM_TO_REPLIES',
        payload: messageBusUtil.createPayload(data)
      });
    }

    // ## DM
    else if ((data === null || data === void 0 ? void 0 : data.notification_type) === 6) {
      messageBusDispatch({
        type: 'SET_ACTIVITY_TIMESTAMP',
        payload: Date.now()
      });
    }
  };
  return {
    newHandler,
    notificationAlertHandler,
    latestHandler
  };
};
export { useMessageBusCallbacks };
//# sourceMappingURL=useMessageBusCallbacks.js.map